<template>
  <!-- <section v-if="data?.results?.length === 0 && !loadingTable">
    No se encontraron resultados. Por favor, prueba modificando tus filtros.
  </section> -->

  <a-table
    row-key="id"
    size="middle"
    ref="tableRef"
    class="tickets-table"
    :columns="columns"
    :data-source="data.results"
    :loading="loadingTable"
    :scroll="{ ...scrollStyle, x: 'max-content' }"
    :pagination="pagination"
    :row-selection="rowSelection"
    :row-class-name="getRowClass"
    @change="handleTableChange"
  >
    <template #headerCell="{ column, title }">
      <template v-if="column.dataIndex === 'whatsapp_username' || column.key === 'whatsapp_username'">
        <span class="table-header-with-tooltip">
          {{ title }}
          <a-tooltip title="Nombre de usuario que el contacto tiene configurado en WhatsApp">
            <InfoCircleOutlined class="header-info-icon" />
          </a-tooltip>
        </span>
      </template>
      <template v-else-if="column.dataIndex === 'whatsapp_user_id' || column.key === 'whatsapp_user_id'">
        <span class="table-header-with-tooltip">
          {{ title }}
          <a-tooltip title="Identificador único que WhatsApp asigna al contacto dentro de cada Business Manager.">
            <InfoCircleOutlined class="header-info-icon" />
          </a-tooltip>
        </span>
      </template>
      <template v-else>
        <span>{{ title }}</span>
      </template>
    </template>

    <template #ticketId="{ record }">
      <span class="ticket_td--id">
        #{{ record.id }}
        <IconIAIntegration v-if="isBeexAi(record)" :width="14" :height="14" />
      </span>
    </template>

    <template #contact="{ record: { client, portfolio, portfolio_id } }">
      <a-space class="contact-space" v-if="client">
        <profile-image :photo="client?.profile_picture" :name="client?.name" size="small" />
        <a-button
          class="table-link-button contact-button"
          type="link"
          @click="handleOpenContactDrawer(client.id, portfolio, portfolio_id)"
        >
          {{ client?.name }}
        </a-button>
      </a-space>

      <span v-else> No identificado </span>
    </template>

    <template #managedBy="{ record: { user_assigned, current_type_support } }">
      <a-space v-if="current_type_support === SupportType.Chatbot">
        <div class="user_profile_wrapper" :style="backGroundImageColor(null)">
          <img :src="chatbotImage" alt="chatbot" class="user_profile_default" />
        </div>

        <span>Chatbot</span>
      </a-space>

      <a-space v-else-if="user_assigned">
        <div class="user_profile_wrapper" :style="backGroundImageColor(user_assigned)">
          <img
            v-if="user_assigned?.picture"
            :src="user_assigned?.picture"
            class="user_profile_picture"
            alt="profile image"
          />
          <img
            v-else
            :src="imageDefault(user_assigned)"
            alt="profile image"
            class="user_profile_default"
            :class="{ agent: user_assigned?.profile_name === 'Agente' }"
          />
        </div>

        <a-button
          class="table-link-button"
          type="link"
          @click="handleOpenUserModal(user_assigned.fullname, user_assigned.id)"
        >
          {{ user_assigned?.fullname }}
        </a-button>
      </a-space>

      <span v-else> - </span>
    </template>

    <template #state="{ record }">
      <ticket-state-tag :state="record.state" />
    </template>

    <template #channels_title>
      Canales

      <a-tooltip title="Números o cuentas asociadas a tu empresa">
        <InfoCircleOutlined :style="{ fontSize: '12px' }" />
      </a-tooltip>
    </template>

    <template #channels="{ record }">
      <div class="channels-group" v-if="record.channels.length > 0">
        <a-space
          :size="10"
          v-for="group in getUniqueChannels(record).channelsWithoutEmail"
          :key="group?.icon"
        >
          <a-tooltip color="white" v-if="group.channel">
            <template #title>
              <span class="channels-icons">{{ group?.channel?.name }}</span>
            </template>
            <img height="18" width="18" :src="group?.channel?.icon" :alt="group?.channel?.name" />
          </a-tooltip>
        </a-space>
        <div v-if="getUniqueChannels(record).emailChannel">
          <a-space
            :size="12"
            v-for="item in [getUniqueChannels(record).emailChannel]"
            :key="item.icon"
          >
            <a-tooltip color="white">
              <template #title>
                <span class="channels-icons"
                  >Ver correo [Correo #{{ item?.channel?.message_id }}] asociado al mismo contacto
                  de este ticket
                </span>
              </template>
              | <img height="18" width="18" :src="item?.channel?.icon" :alt="item?.channel?.name" />
              <LinkOutlined @click="openEmailHistoryDrawer(item?.channel?.message_id)" />
            </a-tooltip>
          </a-space>
        </div>
        <!-- <PopoverChannels :channels="record.channels" :size="18" /> -->
      </div>
      <span v-else>-</span>
    </template>

    <template #identifyChannels_title>
      Identificadores de canales
      <a-tooltip title="Canales asociados a tu empresa">
        <InfoCircleOutlined :style="{ fontSize: '12px' }" />
      </a-tooltip>
    </template>

    <template #identifyChannels="{ record }">
      <a-space :size="8" align="center">
        {{ displayIdentifierText(record) }}
      </a-space>

      <a-tooltip color="white" v-if="record.channels.length > 0">
        <InfoCircleOutlined :style="{ fontSize: '12px', paddingLeft: '5px' }" />
        <template #title>
          <div class="channel-tooltip">
            <h4>Identificadores de canales</h4>
            <ul>
              <li v-for="(item, index) in sortIconChannels(record.channels)" :key="index">
                <a-button type="link" class="table-link-button">
                  <img height="20" width="20" :src="item?.channel?.icon" :alt="item?.channel?.id" />
                </a-button>
                <span class="channel-info">
                  {{ displayChannelInfo(item).text }} 
                  <span v-if="isWhatsappChannel(item)"> - {{ item?.channel?.name }}</span>
                  <span v-if="item.identifier" class="identifier">
                    {{ displayChannelInfo(item).identifier }}
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </template>
      </a-tooltip>
    </template>

    <template #callsContact_title>
      Teléfono del contacto
      <a-tooltip title="Teléfonos interactuados en el ticket asociados al contacto">
        <InfoCircleOutlined :style="{ fontSize: '12px' }" />
      </a-tooltip>
    </template>

    <template #callsContact="{ record }">
      <a-space :size="8" align="center">
        {{ displayContactCalls(record) }}
      </a-space>
      <a-tooltip color="white" v-if="getCallsInfo(record).totalCount > 1">
        <InfoCircleOutlined :style="{ fontSize: '12px', paddingLeft: '5px' }" />
        <template #title>
          <div class="calls-tooltip">
            <h4>{{ getCallsInfo(record).totalCount }} Teléfonos asociados</h4>
            <ul>
              <li v-for="(item, index) in getCallsInfo(record).uniqueChannels" :key="index">
                <span class="channel-info">
                  {{ item.code_country ? "+" + item.code_country : "" }} {{ item.identifier }}
                </span>
              </li>
            </ul>
          </div>
        </template>
      </a-tooltip>
    </template>

    <template #whatsapp_username="{ record }">
      <template v-if="getWhatsappUsernamesInfo(record).totalCount > 1">
        <a-space :size="8" align="center">
          <span>{{ getWhatsappUsernamesInfo(record).totalCount }} usuarios</span>
          <a-tooltip color="white">
            <InfoCircleOutlined :style="{ fontSize: '12px' }" />
            <template #title>
              <div class="calls-tooltip">
                <h4>{{ getWhatsappUsernamesInfo(record).totalCount }} Nombres de usuario</h4>
                <ul>
                  <li v-for="(u, index) in getWhatsappUsernamesInfo(record).list" :key="index">
                    <span class="channel-info">{{ formatWhatsappUsername(u) }}</span>
                  </li>
                </ul>
              </div>
            </template>
          </a-tooltip>
        </a-space>
      </template>
      <span v-else-if="getWhatsappUsernamesInfo(record).totalCount === 1">
        {{ formatWhatsappUsername(getWhatsappUsernamesInfo(record).list[0]) }}
      </span>
      <span v-else>-</span>
    </template>

    <template #whatsapp_user_id="{ record }">
      <template v-if="getWhatsappUserIdsInfo(record).totalCount > 1">
        <a-space :size="8" align="center">
          <span>{{ getWhatsappUserIdsInfo(record).totalCount }} IDs de WhatsApp</span>
          <a-tooltip color="white">
            <InfoCircleOutlined :style="{ fontSize: '12px' }" />
            <template #title>
              <div class="calls-tooltip">
                <h4>{{ getWhatsappUserIdsInfo(record).totalCount }} IDs de WhatsApp asociados</h4>
                <ul>
                  <li v-for="(uid, index) in getWhatsappUserIdsInfo(record).list" :key="index">
                    <span class="channel-info">{{ uid }}</span>
                  </li>
                </ul>
              </div>
            </template>
          </a-tooltip>
        </a-space>
      </template>
      <span v-else-if="getWhatsappUserIdsInfo(record).totalCount === 1">
        {{ getWhatsappUserIdsInfo(record).list[0] }}
      </span>
      <span v-else>-</span>
    </template>

    <template #queues="{ record }">
      <a-space :size="8" align="center">
        <a-typography-text
          :style="record.queue?.length > 25 ? { width: '150px' } : {}"
          :ellipsis="record.queue?.length > 25 ? { tooltip: record.queue } : false"
          :content="record.queue"
        />

        <a-tooltip v-if="record.queue === 'Cola Outbound'">
          <template #title>
            Cola generada por {{ ProductName }} para la distribución de llamadas.
          </template>
          <InfoCircleOutlined :style="{ fontSize: '12px' }" />
        </a-tooltip>
      </a-space>
    </template>

    <template #tags="{ record }">
      <div class="tags__container" v-if="record.tags.length !== 0">
        <a-tooltip v-for="tag in record.tags" :key="tag.name">
          <template #title>{{ tag.name }}</template>

          <div class="tag" :style="{ backgroundColor: `#${tag.color}` }" />
        </a-tooltip>
      </div>

      <span v-else> - </span>
    </template>

    <template #contactType="{ record }">
      <span v-if="record.last_management_group"> {{ record.last_management_group }} </span>

      <span v-else>Sin tipificación</span>
    </template>

    <template #date="{ text }"> {{ dateTimeToSlashFormat(text) }} </template>

    <template #entity="{ record }">
      <a-space>
        <div
          v-if="record.entity?.logo"
          class="name__logo"
          :style="`background-image: url('${record.entity?.logo}')`"
        />
        <div v-else class="name__logo name__logo--empty" />

        <span>{{ record.entity?.name }}</span>
      </a-space>
    </template>

    <template #closed_by_title>
      <span style="white-space: nowrap">
        Resuelto/cerrado por
        <a-tooltip title="Nombre del agente, administrador u owner que resolvió/cerró el ticket. Los tickets resueltos en este módulo no registran el nombre.">
          <InfoCircleOutlined :style="{ fontSize: '12px' }" />
        </a-tooltip>
      </span>
    </template>

    <template #closed_by="{ record }">
      <span>{{ record.closed_by ?? "-" }}</span>
    </template>

    <template #type_closed="{ record }">
      <a-space v-if="closeTypeInfo[record.type_closed]" :size="8" align="center">
        <span>{{ closeTypeInfo[record.type_closed].label }}</span>
        <a-tooltip :title="closeTypeInfo[record.type_closed].tooltip">
          <InfoCircleOutlined :style="{ fontSize: '12px' }" />
        </a-tooltip>
      </a-space>
      <span v-else-if="record.type_closed">{{ record.type_closed }}</span>
      <span v-else>-</span>
    </template>

    <template #actions="{ record }">
      <a-space :size="14" style="margin-left: 10px">
        <a-tooltip>
          <template #title>Ver Historial</template>

          <a-button
            type="link"
            class="table-link-button"
            @click="handleOpenTicketHistoryDrawer(record)"
          >
            <InfoCircleOutlined />
          </a-button>
        </a-tooltip>

        <a-tooltip>
          <template #title>Transferir</template>

          <a-dropdown
            placement="bottomRight"
            :trigger="['click']"
            :overlayStyle="{ width: '220px' }"
            @click="handleTransferClick(record.id)"
            :disabled="record.state === TicketState.finished || !record.enabled_to_transfer"
          >
            <a-button
              :disabled="record.state === TicketState.finished || !record.enabled_to_transfer"
              type="link"
              class="table-link-button"
              @click.prevent
            >
              <SwapOutlined />
            </a-button>

            <template #overlay>
              <a-menu @click="handleDropdownClick($event, record.id, record.queue, record)">
                <a-menu-item key="queues-users">
                  <a-popover placement="left" :overlayClassName="'popover-option'">
                    <template #content>
                      <span>Transfiere el ticket a un usuario de esta</span><br/>
                      <span>u otra cola de la misma campaña</span>
                    </template>
                    <template #title>
                      <span>Transferir por cola y usuario</span>
                    </template>
                    <span>Transferir por cola y usuario</span>
                  </a-popover>
                </a-menu-item>
                <a-menu-item key="users" :disabled="!record.queue">
                  <a-popover placement="left" title="Transferir a un usuario" :overlayClassName="'popover-option'">
                    <template #content>
                      <span>Transfiere el ticket a otra usuario de la</span><br/>
                      <span>misma campaña</span>
                    </template>
                    <template #title>
                      <span>Transferir a un usuario</span>
                    </template>                  
                    <span>Transferir a un usuario</span>
                  </a-popover>
                </a-menu-item> 
                <a-menu-item key="queues">                
                  <a-popover placement="left" title="Transferir a cola" :overlayClassName="'popover-option'">
                    <template #content>
                      <span>Transfiere el ticket a otra cola de la</span><br/>
                      <span>misma campaña</span>
                    </template>
                    <template #title>
                      <span>Transferir a cola</span>
                    </template>
                    <span>Transferir a cola</span>
                    
                  </a-popover>
                </a-menu-item>              
              </a-menu>
            </template>
          </a-dropdown>
        </a-tooltip>

        <a-tooltip>
          <template #title>Editar</template>

          <a-button
            :disabled="record.state === TicketState.finished"
            type="link"
            class="table-link-button"
            @click="handleOpenEditDrawer(record)"
          >
            <EditOutlined />
          </a-button>
        </a-tooltip>

        <a-tooltip>
          <template #title>Resolver</template>

          <a-button
            :disabled="record.state === TicketState.finished"
            type="link"
            class="table-link-button"
            @click="handleResolve(record.id)"
          >
            <CheckOutlined />
          </a-button>
        </a-tooltip>
      </a-space>
    </template>
  </a-table>

  <QueueUserTransferModal
    v-if="openQueueUserTransferModal"
    v-model:open="openQueueUserTransferModal"
    :origin="2"
    :queues="transferData.queues"
    :ticketId="currentTicketId"
    :portfolio="portfolioTransfer"
    :entity="entityTransfer"
    :agentsList="[currentAgentTicket]"
    @update="handleUpdateData"
  />

  <UserTransferModal
    v-if="openUserTransferModal"
    v-model:open="openUserTransferModal"
    :users="transferData.agents"
    :queue="currentQueueName"
    :ticketId="currentTicketId"
    :origin="2"
    :agentsList="[currentAgentTicket]"
    @update="handleUpdateData"
  />

  <QueueTransferModalVue
    v-if="openQueueTransferModal"
    v-model:open="openQueueTransferModal"
    :origin="2"
    :queues="transferData.queues"
    :ticketId="currentTicketId"
    :portfolio="portfolioTransfer"
    :entity="entityTransfer"
    @update="handleUpdateData"
  />

  <DetailDrawer
    v-if="emailHistoryDrawerConfig.visible"
    :emailId="emailHistoryDrawerConfig.email.id"
    @onCloseDrawer="emailHistoryDrawerConfig.visible = false"
  />
</template>

<script lang="ts">
import { ref, computed, inject, createVNode, watch, h } from "vue";
import { useStore } from "vuex";
import { Modal, message } from "ant-design-vue";
import {
  QuestionCircleOutlined,
  InfoCircleOutlined,
  SwapOutlined,
  EditOutlined,
  CheckOutlined,
  LinkOutlined,
} from "@ant-design/icons-vue";

import { TicketState, SupportType, ChannelType } from "@/app/shared/utils/enums";
import { dateTimeToSlashFormat } from "@/app/shared/utils/dates";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { ProductName } from "@/app/shared/utils/constants";

import ProfileImage from "@/app/shared/components/organisms/ProfileImage.vue";
import TicketStateTag from "../tags/TicketStateTag.vue";
import UserTransferModal from "@/app/ticketsManager/components/modals/transfer/UserTransferModal.vue";
import QueueTransferModalVue from "@/app/ticketsManager/components/modals/transfer/QueueTransferModal.vue";
import QueueUserTransferModal from "@/app/ticketsManager/components/modals/transfer/QueueUserTransferModal.vue";
// import PopoverChannels from "@/app/shared/components/molecules/PopoverChannels.vue";
import DetailDrawer from "@/app/workspace/components/drawers/email/DetailDrawer.vue";

import { ticketsTableColumns } from "../../utils/constants";

import chatbotImage from "@/app/users/assets/profiles/chatbot.svg?url";
import crownImage from "@/app/settings/assets/profile/crown.svg?url";
import { Tooltip, Checkbox } from "ant-design-vue";
import { sortIconChannels } from "@/app/common/utils/sortIconChannels";
import IconIAIntegration from "@/app/common/components/atoms/IconIAIntegration.vue";

export default {
  components: {
    ProfileImage,
    TicketStateTag,
    InfoCircleOutlined,
    // PopoverChannels,
    SwapOutlined,
    EditOutlined,
    CheckOutlined,
    UserTransferModal,
    QueueTransferModalVue,
    QueueUserTransferModal,
    LinkOutlined,
    DetailDrawer,
    IconIAIntegration,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    selectedTableRowKeys: {
      type: Array,
      required: true,
    },
    // loadingTable: {
    //   type: Boolean,
    //   required: true,
    // },
    size: {
      type: Number,
      default: 14,
    },
    columns: {
      type: Array,
      required: true,
      default: ticketsTableColumns,
    },
  },
  setup(props, { emit }) {
    const store = useStore();

    const tableRef = ref(null);
    const currentTablePage = computed(() => store.getters["getTablePage"]);
    const loadingTable = computed(() => store.getters["getLoading"]);

    const selectedTableRowKeys = inject<any>("selectedTableRowKeys");
    const updateSelectedTableRowKeys = inject("updateSelectedTableRowKeys");
    const selectedRowsLastChannel = inject<any>("selectedRowsLastChannel");
    const selectedRowsList = inject<any>("selectedRowsList");
    const selectedAll = inject("selectedAll");
    const columnsTable = computed(() => props.columns);

    const emailHistoryDrawerConfig = ref({
      visible: false,
      email: {},
    });

    const closeTypeInfo: Record<string, { label: string; tooltip: string }> = {
      API: {
        label: "API",
        tooltip: "El ticket fue resuelto/cerrado por un consumidor externo vía API.",
      },
      MANUAL: {
        label: "Manual",
        tooltip:
          "El ticket fue resuelto/cerrado de forma manual por un agente, administrador u owner desde Workspace o Gestor de tickets.",
      },
      ESTRATEGIA_DE_WHATSAPP: {
        label: "Estrategia de WhatsApp",
        tooltip:
          "El ticket fue resuelto/cerrado por la configuración del cierre automático de tickets sin respuesta ni atención de la estrategia de WhatsApp por plantilla.",
      },
      SECUENCIA_MULTICANAL: {
        label: "Secuencia multicanal",
        tooltip: "El ticket fue resuelto/cerrado al finalizar la gestión del contacto.",
      },
      AGENTE_IA: {
        label: "Agente IA",
        tooltip:
          "El ticket fue resuelto/cerrado bajo la gestión de un agente IA según su configuración.",
      },
      CHATBOT: {
        label: "Chatbot",
        tooltip:
          "El ticket fue resuelto/cerrado bajo la gestión de un chatbot según su configuración.",
      },
      ESTRATEGIA_DE_SMS: {
        label: "Estrategia de SMS",
        tooltip: "El ticket fue resuelto/cerrado desde el webhook de SMS en una estrategia de este mismo.",
      },
      SISTEMA: {
        label: "Sistema",
        tooltip:
          "El ticket fue resuelto/cerrado al inactivar o eliminar el agente IA, chatbot, cola, campaña, empresa, identificador, contacto o su teléfono al que estaba asociado.",
      },
    };

    watch(selectedRowsList, (newList) => {
      if (newList?.length) setNewMargin(340);
      else setNewMargin(280);
    });

    const { scrollStyle, setNewMargin } = useScrollResize({ headerMargin: 280 });

    const rowSelection = {
      selectedRowKeys: computed(() => selectedTableRowKeys.value),
      onChange: (selectedRowKeys, selectedRows) => {
        if (selectedRowsList.value == 0)
          selectedRowsList.value = selectedRows.map((el) => ({
            ...el,
            page: currentTablePage.value,
          }));
        else {
          selectedRowsList.value = selectedRowsList.value.filter(
            (row) => row.page !== currentTablePage.value
          );
          selectedRowsList.value.push(
            ...selectedRows.map((el) => ({ ...el, page: currentTablePage.value }))
          );
        }
        selectedRowsLastChannel.value = selectedRowsList.value.map(
          (row) => row?.channels?.[0]?.channel
        );
        updateSelectedTableRowKeys(
          selectedRowsList.value == 0 ? selectedRows : selectedRowsList.value.map((el) => el.id)
        );
      },
      onSelectAll: (selected, selectedRows) => {
        selectedAll.value = selected;
        if (selected) {
          // Si se selecciona "Seleccionar Todos", agregar todas las filas visibles a la lista
          const itemsAdd = selectedRows
            .filter(
              (record) => !(record.state === TicketState.finished || !record.enabled_to_transfer)
            )
            .map((el) => ({
              ...el,
              page: currentTablePage.value,
            }));
          selectedRowsList.value = [...selectedRowsList.value, ...itemsAdd];
        } else {
          // Si se deselecciona "Seleccionar Todos", eliminar las filas visibles de la lista
          selectedRowsList.value = selectedRowsList.value.filter(
            (row) => row.page !== currentTablePage.value
          );
        }

        selectedRowsLastChannel.value = selectedRowsList.value.map(
          (row) => row?.channels?.[0]?.channel
        );

        // Actualizar las llaves de las filas seleccionadas
        updateSelectedTableRowKeys(
          selectedRowsList.value.length === 0 ? [] : selectedRowsList.value.map((el) => el.id)
        );
      },
      allRowsDisabled: computed(() => {
        return props.data?.results?.every((record) => {
          return record.state === TicketState.finished || !record.enabled_to_transfer;
        });
      }),

      columnTitle: ({ checked, indeterminate, onChange }) => {
        // Calcular si "Seleccionar Todo" debe estar marcado o indeterminado
        const resultsSelected = props.data?.results?.filter(
          (record: any) => record.state !== TicketState.finished && record.enabled_to_transfer
        );

        console.log(resultsSelected, "results selected");
        let allChecked = false;
        let partiallyChecked = false;

        if (resultsSelected && resultsSelected?.length > 0) {
          allChecked = resultsSelected?.every((record: any) =>
            selectedTableRowKeys.value.includes(record.id)
          );
          partiallyChecked = resultsSelected?.some((record: any) =>
            selectedTableRowKeys.value.includes(record.id)
          );
        }
        return h(
          Tooltip,
          {
            title: rowSelection.allRowsDisabled.value
              ? "No hay tickets disponibles para seleccionar en esta página"
              : "",
          },
          [
            h(Checkbox, {
              checked: allChecked,
              indeterminate: !allChecked && partiallyChecked,
              // onChange,
              disabled: rowSelection.allRowsDisabled.value,
              onChange: (e) => {
                const isChecked = e.target.checked;
                // Llamar a la función onSelectAll con los parámetros correspondientes
                rowSelection.onSelectAll(isChecked, props.data.results);
              },
            }),
          ]
        );
      },
      getCheckboxProps: (record) => ({
        disabled: record.state === TicketState.finished || !record.enabled_to_transfer,
      }),
    };

    const pagination = computed(() => ({
      total: props.data?.count,
      current: currentTablePage.value,
      pageSize: 50,
      showSizeChanger: false,
    }));

    const displayIdentifierText = (record) => {
      if (!record) return "-";
      if (!record.channels.length > 0) return "-";

      const channelCount = record.channels.length;
      if (channelCount > 0) {
        return `${channelCount} ${channelCount === 1 ? "identificador" : "identificadores"}`;
      }
    };

    const displayChannelInfo = (item) => {
      if (!item || Object.keys(item).length === 0) {
        return { text: "", identifier: "" };
      }

      const { channel_customer, channel } = item;
      const { alias, data_parameters } = channel_customer;

      const channelIdentifier = data_parameters?.phone_number
        ? `(${data_parameters.phone_number})`
        : "";

      return {
        text: alias || channelIdentifier,
        identifier: channel?.id === ChannelType.Voice ? "Número aleatorio" : channelIdentifier,
      };
    };

    const isWhatsappChannel = (item) => {
      return (
        item.channel?.id === ChannelType.Whatsapp ||
        item.channel?.id === ChannelType.WhatsappVoice
      )
    };

    const getChannelsByUniqueIdentifier = (data) => {
      const existIdentifiers = {};
      return data.filter((element) => {
        const identifier = element.identifier;
        if (!existIdentifiers[identifier]) {
          existIdentifiers[identifier] = true;
          return true;
        }
        return false;
      });
    };

    const getUniqueChannels = (data) => {
      const uniqueChannels = {};
      const result = data.channels.filter((element) => {
        const channel = element?.channel?.name;

        // Inbound and Outbound are the same channel
        const equivalentChannel = channel === "Telefonia Entrante" ? "Telefonia Saliente" : channel;

        if (!uniqueChannels[equivalentChannel]) {
          uniqueChannels[equivalentChannel] = true;
          return true;
        }
        return false;
      });

      const finalChannels = result.map((obj) => {
        if (
          obj?.channel?.name === "Telefonia Entrante" ||
          obj?.channel?.name === "Telefonia Saliente"
        ) {
          return { ...obj, channel: { ...obj?.channel, name: "Voz" } };
        }
        return obj;
      });

      const sortedChannel = sortIconChannels(finalChannels)

      const channelsWithoutEmail = sortedChannel.filter((item) => item?.channel?.name !== "EMAIL");
      const emailChannel = sortedChannel.find((item) => item?.channel?.name === "EMAIL");

      // console.log(finalChannels, "finalChannels");

      return {
        channelsWithoutEmail,
        emailChannel,
        chatbotImage,
        crownImage,
      };
    };

    const getChannelsByName = (data, channelId) => {
      return data.channels.filter((channel) => channel?.channel?.id === channelId);
    };

    const getCallsInfo = (record) => {
      // const whatsappChannels = getChannelsByName(record, "WhatsApp");
      // const outboundChannels = getChannelsByName(record, "Telefonia Saliente");
      // const inboundChannels = getChannelsByName(record, "Telefonia Entrante");

      const allChannels = [
        ChannelType.Whatsapp,
        ChannelType.WhatsappVoice,
        ChannelType.Voice,
        ChannelType.VoiceInbound,
        ChannelType.Sms,
      ].flatMap((channelId) => getChannelsByName(record, channelId));

      // const allChannels = [...whatsappChannels, ...outboundChannels, ...inboundChannels];
      const uniqueChannels = getChannelsByUniqueIdentifier(allChannels);

      const totalCount = uniqueChannels.length;

      return {
        uniqueChannels,
        totalCount,
      };
    };

    const displayContactCalls = (record) => {
      if (!record.channels.length > 0) return "-";
      const { uniqueChannels, totalCount } = getCallsInfo(record);

      if (totalCount > 1) {
        return totalCount + " Teléfonos asociados";
      } else if (totalCount === 1) {
        const hasCodeCountry = uniqueChannels[0]?.code_country !== null;
        const codeCountry = hasCodeCountry ? uniqueChannels[0]?.code_country : "";
        const identifier = uniqueChannels[0]?.identifier;
        return `${hasCodeCountry ? "+" + codeCountry : ""} ${identifier || "-"}`;
      } else {
        return "-";
      }
    };

    const handleTableChange = (page) => {
      emit("page-change", page.current);
    };

    // Button actions

    const handleOpenTicketHistoryDrawer = (record) => {
      emit("open-ticket-history-drawer", record);
    };

    const getChannelIdentifier = (channel) => {
      const code_country = channel?.code_country || "";
      const channelPhone = channel?.associate || channel?.identifier;

      return channel?.channel_customer?.data_parameters?.alias || `${code_country} ${channelPhone}`;
    };

    const handleResolve = (ticketId) => {
      Modal.confirm({
        title: `Estás a punto de resolver el ticket #${ticketId}. ¿Deseas continuar?`,
        content:
          "Recuerda que el chat o llamada en curso se finalizará. Además, si se encuentra en llamada, se asignará una tipificación por defecto.",
        icon: createVNode(QuestionCircleOutlined),
        centered: true,
        onOk: async () => {
          try {
            await store.dispatch("resolveSingleTicket", ticketId);
            message.success("Se ha resuelto el ticket correctamente");
            updateSelectedTableRowKeys([]);
            handleUpdateData();
          } catch (error) {
            console.log(error);
            message.error("Ocurrió un error");
          }
        },
        okText: "Si, Resolver",
        cancelText: "No, Cancelar",
      });
    };

    const handleUpdateData = () => emit("update-data");

    const handleOpenEditDrawer = (ticket) => {
      emit("open-edit-drawer", ticket);
    };

    const transferData = computed(() => store.getters["getTransferData"]);

    const handleTransferClick = async (ticketId) => {
      await store.dispatch("fetchTransferData", { ticket: ticketId, origin: 2 });
    };

    const openUserTransferModal = ref(false);
    const openQueueTransferModal = ref(false);
    const openQueueUserTransferModal = ref(false);
    const currentTicketId = ref();
    const currentQueueName = ref("");
    const portfolioTransfer = ref();
    const entityTransfer = ref();
    const currentAgentTicket = ref();

    const handleDropdownClick = async ({ key } = {}, ticketId, queueName, ticket) => {
      console.log({ key, ticketId });

      if (key === "users") openUserTransferModal.value = true;
      if (key === "queues") openQueueTransferModal.value = true;
      if (key === "queues-users") openQueueUserTransferModal.value = true;
      currentTicketId.value = ticketId;
      currentQueueName.value = queueName;
      portfolioTransfer.value = { name: ticket?.portfolio, id: ticket?.portfolio_id };
      entityTransfer.value = ticket?.entity;
      currentAgentTicket.value = ticket.user_assigned;
    };

    // Details

    const handleOpenContactDrawer = (contactId, campaign, portfolioId) => {
      console.log(portfolioId, "campaign handleOpenContactDrawer");
      emit("open-contact-drawer", contactId, campaign, portfolioId);
    };

    const handleOpenUserModal = (userName, userId) => {
      emit("open-user-modal", { userName, userId });
    };

    // User Icon
    const getProfileImage = (profile) => {
      return new URL(`../../../users/assets/profiles/${profile}`, import.meta.url).href;
    };

    const imageDefault = (user) => {
      const profile = user?.icon || "";
      let url = "";
      if (profile === "") {
        url = crownImage;
      } else {
        url = getProfileImage(profile);
      }
      return url;
    };

    const backGroundImageColor = (user) => {
      const background = user?.icon || "";
      const typeProfile = user?.profile_name;

      if (background === "") {
        return "background: #E6F7FF";
      } else if (typeProfile === "Supervisor") {
        return "background: #E6F7FF";
      } else if (typeProfile === "Agente") {
        return "background: #FFF7E6";
      }

      return "background: #E6F7FF";
    };

    const openEmailHistoryDrawer = (id) => {
      console.log(id, "openemail history");
      emailHistoryDrawerConfig.value.visible = true;
      emailHistoryDrawerConfig.value.email = { id: id };
    };

    const getRowClass = (record: any) => {
      return isBeexAi(record) ? "row-botai" : "";
    };

    const isBeexAi = (record: any) => {
      // tiene tag Beex AI (mensajeria: "BotAI Message", voz: "Agente IA")
      return record.tags.find(
        (el: any) => ["BotAI Message", "Agente IA"].includes(el.name) && el.is_permanent
      );
    };

    const getWhatsappUsernamesInfo = (record: any) => {
      const source = record.whatsapp_username;
      const list: string[] = [];
      if (Array.isArray(source)) {
        source.forEach((u) => {
          if (u && !list.includes(String(u).trim())) list.push(String(u).trim());
        });
      } else if (source && String(source).trim()) {
        list.push(String(source).trim());
      }
      // Also check record.channels if available
      if (Array.isArray(record.channels)) {
        record.channels.forEach((c: any) => {
          if (c?.whatsapp_username && !list.includes(String(c.whatsapp_username).trim())) {
            list.push(String(c.whatsapp_username).trim());
          }
        });
      }
      return {
        list,
        totalCount: list.length,
      };
    };

    const getWhatsappUserIdsInfo = (record: any) => {
      const source = record.whatsapp_user_id;
      const list: string[] = [];
      if (Array.isArray(source)) {
        source.forEach((uid) => {
          if (uid && !list.includes(String(uid).trim())) list.push(String(uid).trim());
        });
      } else if (source && String(source).trim()) {
        list.push(String(source).trim());
      }
      // Also check record.channels if available
      if (Array.isArray(record.channels)) {
        record.channels.forEach((c: any) => {
          if (c?.whatsapp_user_id && !list.includes(String(c.whatsapp_user_id).trim())) {
            list.push(String(c.whatsapp_user_id).trim());
          }
        });
      }
      return {
        list,
        totalCount: list.length,
      };
    };

    const formatWhatsappUsername = (username: any) => {
      if (!username) return "-";
      const trimmed = String(username).trim();
      if (!trimmed) return "-";
      return trimmed.startsWith("@") ? trimmed : `@${trimmed}`;
    };

    return {
      scrollStyle,
      TicketState,
      tableRef,
      rowSelection,
      columns: columnsTable,
      pagination,
      handleTableChange,
      handleOpenTicketHistoryDrawer,
      getChannelIdentifier,
      handleResolve,
      handleOpenEditDrawer,
      transferData,
      handleTransferClick,
      handleDropdownClick,
      handleOpenContactDrawer,
      handleOpenUserModal,
      imageDefault,
      backGroundImageColor,
      dateTimeToSlashFormat,
      SupportType,
      handleUpdateData,
      displayIdentifierText,
      displayChannelInfo,
      isWhatsappChannel,
      displayContactCalls,
      getCallsInfo,
      getUniqueChannels,
      currentQueueName,
      openUserTransferModal,
      openQueueTransferModal,
      openQueueUserTransferModal,
      currentTicketId,
      emailHistoryDrawerConfig,
      openEmailHistoryDrawer,
      ProductName,
      selectedAll,
      loadingTable,
      chatbotImage,
      portfolioTransfer,
      entityTransfer,
      currentAgentTicket,
      sortIconChannels,
      isBeexAi,
      getRowClass,
      formatWhatsappUsername,
      getWhatsappUsernamesInfo,
      getWhatsappUserIdsInfo,
      closeTypeInfo,
    };
  },
};
</script>

<style lang="sass" scoped>
.contact-button
  max-width: 100%
  overflow: hidden
  text-overflow: ellipsis

:deep(.contact-button > span)
  display: initial

.tag
  width: 27px
  height: 4px
  border-radius: 3.5px

.tags__container
  display: flex
  gap: 4px
  flex-wrap: wrap

.table-link-button
  padding: 0

.tickets-table
  margin-top: 8px

.user_profile
  &_wrapper
    width: 28px
    height: 28px
    border-radius: 50%
    display: grid
    place-content: center

  &_picture
    width: 28px
    height: 28px
    border-radius: 50%

  &_default
    width: 28px
    height: 28px
    border-radius: 50%
    border: 1px solid $geekblue-6
    color: $geekblue-7
    //background-color: $geekblue-1
    padding: 5px


section
  display: grid
  justify-items: center
  color: $gray-6
  font-size: 20px
  margin: auto 0

.name
  display: flex
  align-items: center
  position: relative

  &__logo
    display: block
    width: 28px
    height: 28px
    background-size: cover
    background-position: center
    border-radius: 50%

    &--empty
      background-image: url('../../../entities/assets/briefcase-blue.svg')

.channels-group
  display: inline-flex
  gap: 10px
.channels-icons
  color: black
.channel-tooltip
  color: black
  width: fit-content
  ul
    list-style: none
    text-align: left
    padding: 0
    margin: 0
    li
      white-space: nowrap
      .channel-info
        padding-left: 5px
        .identifier
          color: $gray-7
          padding-left: 25px
          display: block

.calls-tooltip
  color: black
  width: fit-content
  ul
    margin: 0
    padding-left: 20px

.agent
  filter: invert(55%) sepia(46%) saturate(1606%) hue-rotate(351deg) brightness(105%) contrast(96%)

.contact-space:deep(.ant-space-item:nth-child(2))
  min-width: 0
  flex: 1 1 auto
:deep(.tickets-table .ant-table)
  width: 100%

:global(.ant-popover.popover-option)
  z-index: 1800 !important

:deep(.row-botai),
:deep(.row-botai .ant-table-cell-fix-left),
:deep(.row-botai .ant-table-cell-fix-right)
  background: linear-gradient(0deg, rgba(249, 240, 255, 0.48), rgba(249, 240, 255, 0.48)), #ffffff !important

:deep(.ant-table-row-selected.row-botai), 
:deep(.ant-table-row-selected.row-botai > td),
:deep(.ant-table-row-selected.row-botai .ant-table-cell-fix-left),
:deep(.ant-table-row-selected.row-botai .ant-table-cell-fix-right)
  background-color: rgba(239, 219, 255, 0.6) !important

:deep(tr.row-botai:hover > td)
  background: linear-gradient(0deg, rgba(249, 240, 255, 0.48), rgba(249, 240, 255, 0.48)), #ffffff !important

.row-botai
  .ticket_td--id
    background: linear-gradient(to bottom, #762ECF, #D62FA0)
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    display: flex
    align-items: center
    gap: 5px

.table-header-with-tooltip
  display: inline-flex
  align-items: center
  white-space: nowrap
  gap: 4px

  .header-info-icon
    font-size: 14px
    color: #8c8c8c
    flex-shrink: 0
</style>

<style scoped>
.tickets-table .ant-space.ant-space-horizontal.ant-space-align-center.contact-space {
  max-width: 100% !important;
}
.tickets-table .contact-space .ant-space-item {
  max-width: calc(100% - 36px) !important;
}
</style>
